import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { columnTitleMap } from './config'

import type { Column } from '@app/components/base/Table/types'

import type { ColumnsKeys, ProductsListColumns } from './types'

const getOptions = (): Array<Column<ProductsListColumns>> => {
  const columnsKeys = Object.keys(columnTitleMap).filter(key => !['status'].includes(key)) as ColumnsKeys

  return columnsKeys.map(key => {
    const column: Column<ProductsListColumns> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }
    return column
  })
}

export const getColumns = (): Array<Column<ProductsListColumns>> => {
  return getColumnsFromMap<ProductsListColumns>({
    columnTitleMap,
    options: getOptions()
  })
}
